// extracted by mini-css-extract-plugin
export default {"cls1":"qgut2VrpPPRyi_rnciw3","cls2":"Hz74m_RFRf31oXEOjTZ0 qgut2VrpPPRyi_rnciw3"};